import { useEffect } from 'react';
import { useSession, useTenant } from '../app';
import { Kicker, Link } from '../components';

/** Kontoseite (Konzept 4.8) – Stufe 1 zeigt die Grunddaten; Käufe, Geräte und Löschung folgen. */
export function AccountPage() {
  const tenant = useTenant();
  const session = useSession();
  useEffect(() => {
    document.title = `Konto – ${tenant.name}`;
  }, [tenant.name]);

  return (
    <main className="page page--narrow">
      <Kicker>Dein Konto</Kicker>
      <h1>{session.name ?? 'Konto'}</h1>
      <div className="card">
        <dl className="facts">
          <dt>E-Mail</dt>
          <dd>{session.email}</dd>
          <dt>Name</dt>
          <dd>{session.name ?? <span className="muted">nicht angegeben</span>}</dd>
          <dt>Anmeldung</dt>
          <dd>Per Link oder Code – kein Passwort nötig.</dd>
        </dl>
      </div>
      <p className="muted small">Käufe, angemeldete Geräte und das Löschen des Kontos kommen in der nächsten Ausbaustufe hierher.</p>
      <p>
        <Link href="/" className="button button--secondary">
          Zur Bibliothek
        </Link>
      </p>
    </main>
  );
}

export function LegalPage({ kind }: { kind: 'impressum' | 'datenschutz' }) {
  const tenant = useTenant();
  const text = tenant.legal[kind];
  const title = kind === 'impressum' ? 'Impressum' : 'Datenschutz';
  useEffect(() => {
    document.title = `${title} – ${tenant.name}`;
  }, [title, tenant.name]);
  return (
    <main className="page page--narrow legal">
      <h1>{title}</h1>
      {text ? text.split(/\n\s*\n/).map((p, i) => <p key={i}>{p}</p>) : <p className="muted">Dieser Text wurde noch nicht hinterlegt.</p>}
    </main>
  );
}
